// const CREATE_RELEASE_VERSION = 'CREATE_RELEASE_VERSION';

const ACTION_TYPES = {
  // CREATE_RELEASE_VERSION,
  VALIDATE_JQL_CLICK: 'VALIDATE_JQL_CLICK',
  HANDLE_FORM_SUBMIT: 'HANDLE_FORM_SUBMIT',
};

export default ACTION_TYPES;
